import { useQueryClient } from "react-query";
import PropTypes from "prop-types";
import { useGlobalPrivateChannelListener } from "../Hooks/useGlobalPrivateChannelListener";

export const TimeRecordTotalRealtimeEvents = ({ parentType, parentId }) => {
  const queryClient = useQueryClient();
  const handler = ({ parent_id, parent_type }) => {
    queryClient.invalidateQueries(["time-records-user-total", parent_type, parent_id]);
  };

  const taskUpdatedHandler = ({ id }) => {
    if (parentType === "Task" && parentId === id) {
      queryClient.invalidateQueries(["time-records-user-total", "Task", id]);
    }
  };

  const projectUpdatedHandler = ({ id }) => {
    if (parentType === "Project" && parentId === id) {
      queryClient.invalidateQueries(["time-records-user-total", "Project", id]);
    }
  };

  const contextUpdatedListener = ({ id, type }) => {
    if (parentType === type && parentId === id) {
      queryClient.invalidateQueries(["time-records-user-total", type, id]);
    }
  };

  useGlobalPrivateChannelListener("TimeRecordCreated", handler);
  useGlobalPrivateChannelListener("TimeRecordUpdated", handler);
  useGlobalPrivateChannelListener("TimeRecordMovedToTrash", handler);
  useGlobalPrivateChannelListener("TimeRecordRestoredFromTrash", handler);
  useGlobalPrivateChannelListener("TimeRecordMovedToProject", handler);
  useGlobalPrivateChannelListener("TimeRecordRemovedFromProject", handler);
  useGlobalPrivateChannelListener("TaskUpdated", taskUpdatedHandler);
  useGlobalPrivateChannelListener("ProjectUpdated", projectUpdatedHandler);
  useGlobalPrivateChannelListener("TrackingContextUpdated", contextUpdatedListener);

  return null;
};

TimeRecordTotalRealtimeEvents.propTypes = {
  parentId: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
};
